// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { PotentialOperationDetailsFragmentDoc, TradePartnerContactFragmentDoc, TradePartnerFragmentDoc, HistoryFeedInfoFragmentDoc, ChangeEventTypeFragmentDoc } from '../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemTemplateLineItemsTabQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ItemTemplateLineItemsTabQuery = { __typename?: 'Query', itemTemplate: { __typename?: 'ItemTemplate', id: string, name: string, displayName: string, isReadyHomeTemplate: boolean, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlan?: { __typename?: 'ReadyPlan', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', displayName: string, shortName?: string | null | undefined, active: boolean, id: string, name: string, type: { __typename?: 'GlobalOptionType', isElevation: boolean, isSpecLevel: boolean, id: string, name: string }, parentOption?: { __typename?: 'ReadyPlanOption', id: string, name: string, shortName?: string | null | undefined } | null | undefined }> } | null | undefined }, unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', id: string, name: string }>, locations: Array<{ __typename?: 'Location', id: string, name: string }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string, displayName: string }> };

export type ItemTemplateItemVersionsPage_GroupsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ItemTemplateItemVersionFilter>;
  order?: Types.InputMaybe<Array<Types.ItemTemplateItemVersionOrder> | Types.ItemTemplateItemVersionOrder>;
}>;


export type ItemTemplateItemVersionsPage_GroupsQuery = { __typename?: 'Query', itemTemplateItemVersionsPage: { __typename?: 'ItemTemplateItemVersionsPage', groupTotals: Array<{ __typename?: 'ItemTemplateItemVersionGroupTotal', groupId: string, totalCostInCents: number, itivsInGroup: number, itivIdsInGroup: Array<string>, displayName: string }> } };

export type ItemTemplateItemVersionsPageQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ItemTemplateItemVersionFilter>;
  subFilter?: Types.InputMaybe<Types.ItemTemplateItemVersionFilter>;
  highlightChanges?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  order?: Types.InputMaybe<Array<Types.ItemTemplateItemVersionOrder> | Types.ItemTemplateItemVersionOrder>;
}>;


export type ItemTemplateItemVersionsPageQuery = { __typename?: 'Query', itemTemplateItemVersionsPage: { __typename?: 'ItemTemplateItemVersionsPage', items: Array<{ __typename?: 'ItemTemplateItemVersion', id: string, costType: Types.CostType, quantity?: number | null | undefined, totalCostInCents: number, unitCostInCents: number, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, internalNote?: string | null | undefined, name: string, displayName: string, isSelection: boolean, scopeChangeType: Types.ScopeChangeType, scopeChangeReasonNote?: string | null | undefined, otherOptionIds: Array<string>, elevationIds: Array<string>, specOptionIds: Array<string>, basedOn?: { __typename?: 'ItemTemplateItem', id: string, name: string, costType: Types.CostType, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, elevationIds: Array<string>, specOptionIds: Array<string>, otherOptionIds: Array<string>, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, preferredBidContractLineItem?: { __typename?: 'BidContractLineItem', unitCostInCents: number, totalCostInCents: number, id: string, name: string } | null | undefined, baseProduct?: { __typename?: 'Product', id: string, name: string } | null | undefined, bidItem?: { __typename?: 'BidItem', displayName: string, id: string, name: string } | null | undefined } | null | undefined, scope: { __typename?: 'ItemTemplateItem', id: string, bidItemTemplateItem?: { __typename?: 'ItemTemplateItem', id: string } | null | undefined, basedOn?: { __typename?: 'ItemTemplateItem', totalCostInCents: number, id: string, name: string } | null | undefined, template: { __typename?: 'ItemTemplate', id: string, development?: { __typename?: 'Development', id: string } | null | undefined } }, slot: { __typename?: 'ItemSlot', isSelection: boolean, id: string, name: string, item: { __typename?: 'Item', id: string, name: string, fullCode: string, isSelection: boolean, costCode: { __typename?: 'CostCode', id: string, name: string, displayName: string } }, costTypeDetail: { __typename?: 'CostTypeDetail', name: string, code: Types.CostType }, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean } }, preferredBidContractLineItem?: { __typename?: 'BidContractLineItem', unitCostInCents: number, totalCostInCents: number, id: string, name: string } | null | undefined, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }, bidItem?: { __typename?: 'BidItem', displayName: string, code: string, id: string, name: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, items: Array<{ __typename?: 'Item', id: string }>, products: Array<{ __typename?: 'Product', id: string, name: string }> } | null | undefined, baseProduct?: { __typename?: 'Product', id: string, costInCents?: number | null | undefined, name: string, variants?: Array<{ __typename?: 'Product', id: string, costInCents?: number | null | undefined, name: string, items: Array<{ __typename?: 'Item', id: string }> }> | null | undefined, items: Array<{ __typename?: 'Item', id: string }> } | null | undefined, item: { __typename?: 'Item', id: string, name: string, fullCode: string, isSelection: boolean, costCode: { __typename?: 'CostCode', id: string, name: string, displayName: string } }, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canDeleteItem: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number }, groupTotals: Array<{ __typename?: 'ItemTemplateItemVersionGroupTotal', groupId: string, totalCostInCents: number, itivsInGroup: number, itivIdsInGroup: Array<string>, displayName: string }> } };

export type ItemTemplateLineItemsTab_GroupByFragment = { __typename?: 'ItemTemplateItemVersionGroupTotal', groupId: string, totalCostInCents: number, itivsInGroup: number, itivIdsInGroup: Array<string>, displayName: string };

export type ItemTemplateDetailFragment = { __typename?: 'ItemTemplate', id: string, name: string, displayName: string, isReadyHomeTemplate: boolean, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlan?: { __typename?: 'ReadyPlan', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', displayName: string, shortName?: string | null | undefined, active: boolean, id: string, name: string, type: { __typename?: 'GlobalOptionType', isElevation: boolean, isSpecLevel: boolean, id: string, name: string }, parentOption?: { __typename?: 'ReadyPlanOption', id: string, name: string, shortName?: string | null | undefined } | null | undefined }> } | null | undefined };

export type ItemTemplateLineItemsTab_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', displayName: string, shortName?: string | null | undefined, active: boolean, id: string, name: string, type: { __typename?: 'GlobalOptionType', isElevation: boolean, isSpecLevel: boolean, id: string, name: string }, parentOption?: { __typename?: 'ReadyPlanOption', id: string, name: string, shortName?: string | null | undefined } | null | undefined };

export type ItemTemplateItemLineItemFragment = { __typename?: 'ItemTemplateItemVersion', id: string, costType: Types.CostType, quantity?: number | null | undefined, totalCostInCents: number, unitCostInCents: number, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, internalNote?: string | null | undefined, name: string, displayName: string, isSelection: boolean, scopeChangeType: Types.ScopeChangeType, scopeChangeReasonNote?: string | null | undefined, otherOptionIds: Array<string>, elevationIds: Array<string>, specOptionIds: Array<string>, scope: { __typename?: 'ItemTemplateItem', id: string, bidItemTemplateItem?: { __typename?: 'ItemTemplateItem', id: string } | null | undefined, basedOn?: { __typename?: 'ItemTemplateItem', totalCostInCents: number, id: string, name: string } | null | undefined, template: { __typename?: 'ItemTemplate', id: string, development?: { __typename?: 'Development', id: string } | null | undefined } }, slot: { __typename?: 'ItemSlot', isSelection: boolean, id: string, name: string, item: { __typename?: 'Item', id: string, name: string, fullCode: string, isSelection: boolean, costCode: { __typename?: 'CostCode', id: string, name: string, displayName: string } }, costTypeDetail: { __typename?: 'CostTypeDetail', name: string, code: Types.CostType }, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean } }, preferredBidContractLineItem?: { __typename?: 'BidContractLineItem', unitCostInCents: number, totalCostInCents: number, id: string, name: string } | null | undefined, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }, bidItem?: { __typename?: 'BidItem', displayName: string, code: string, id: string, name: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, items: Array<{ __typename?: 'Item', id: string }>, products: Array<{ __typename?: 'Product', id: string, name: string }> } | null | undefined, baseProduct?: { __typename?: 'Product', id: string, costInCents?: number | null | undefined, name: string, variants?: Array<{ __typename?: 'Product', id: string, costInCents?: number | null | undefined, name: string, items: Array<{ __typename?: 'Item', id: string }> }> | null | undefined, items: Array<{ __typename?: 'Item', id: string }> } | null | undefined, item: { __typename?: 'Item', id: string, name: string, fullCode: string, isSelection: boolean, costCode: { __typename?: 'CostCode', id: string, name: string, displayName: string } }, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canDeleteItem: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type ItemTemplateItemLineItemWithChangesFragment = { __typename?: 'ItemTemplateItemVersion', id: string, costType: Types.CostType, quantity?: number | null | undefined, totalCostInCents: number, unitCostInCents: number, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, internalNote?: string | null | undefined, name: string, displayName: string, isSelection: boolean, scopeChangeType: Types.ScopeChangeType, scopeChangeReasonNote?: string | null | undefined, otherOptionIds: Array<string>, elevationIds: Array<string>, specOptionIds: Array<string>, basedOn?: { __typename?: 'ItemTemplateItem', id: string, name: string, costType: Types.CostType, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, elevationIds: Array<string>, specOptionIds: Array<string>, otherOptionIds: Array<string>, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, preferredBidContractLineItem?: { __typename?: 'BidContractLineItem', unitCostInCents: number, totalCostInCents: number, id: string, name: string } | null | undefined, baseProduct?: { __typename?: 'Product', id: string, name: string } | null | undefined, bidItem?: { __typename?: 'BidItem', displayName: string, id: string, name: string } | null | undefined } | null | undefined, scope: { __typename?: 'ItemTemplateItem', id: string, bidItemTemplateItem?: { __typename?: 'ItemTemplateItem', id: string } | null | undefined, basedOn?: { __typename?: 'ItemTemplateItem', totalCostInCents: number, id: string, name: string } | null | undefined, template: { __typename?: 'ItemTemplate', id: string, development?: { __typename?: 'Development', id: string } | null | undefined } }, slot: { __typename?: 'ItemSlot', isSelection: boolean, id: string, name: string, item: { __typename?: 'Item', id: string, name: string, fullCode: string, isSelection: boolean, costCode: { __typename?: 'CostCode', id: string, name: string, displayName: string } }, costTypeDetail: { __typename?: 'CostTypeDetail', name: string, code: Types.CostType }, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean } }, preferredBidContractLineItem?: { __typename?: 'BidContractLineItem', unitCostInCents: number, totalCostInCents: number, id: string, name: string } | null | undefined, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }, bidItem?: { __typename?: 'BidItem', displayName: string, code: string, id: string, name: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, items: Array<{ __typename?: 'Item', id: string }>, products: Array<{ __typename?: 'Product', id: string, name: string }> } | null | undefined, baseProduct?: { __typename?: 'Product', id: string, costInCents?: number | null | undefined, name: string, variants?: Array<{ __typename?: 'Product', id: string, costInCents?: number | null | undefined, name: string, items: Array<{ __typename?: 'Item', id: string }> }> | null | undefined, items: Array<{ __typename?: 'Item', id: string }> } | null | undefined, item: { __typename?: 'Item', id: string, name: string, fullCode: string, isSelection: boolean, costCode: { __typename?: 'CostCode', id: string, name: string, displayName: string } }, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canDeleteItem: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type ItemTemplateLineItemsTab_ItemSlotFragment = { __typename?: 'ItemSlot', isSelection: boolean, id: string, name: string, item: { __typename?: 'Item', id: string, name: string, fullCode: string, isSelection: boolean, costCode: { __typename?: 'CostCode', id: string, name: string, displayName: string } }, costTypeDetail: { __typename?: 'CostTypeDetail', name: string, code: Types.CostType }, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean } };

export type ItemTemplateItemBaseProductFragment = { __typename?: 'Product', id: string, costInCents?: number | null | undefined, name: string, items: Array<{ __typename?: 'Item', id: string }> };

export type ItemTemplateItemItemFragment = { __typename?: 'Item', id: string, name: string, fullCode: string, isSelection: boolean, costCode: { __typename?: 'CostCode', id: string, name: string, displayName: string } };

export type ItemTemplateItemCostCodeFragment = { __typename?: 'CostCode', id: string, name: string, displayName: string };

export type ItemTemplateItemBidContractLineItemFragment = { __typename?: 'BidContractLineItem', unitCostInCents: number, totalCostInCents: number, id: string, name: string };

export type ItemTemplateItemBidItemFragment = { __typename?: 'BidItem', displayName: string, code: string, id: string, name: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, items: Array<{ __typename?: 'Item', id: string }>, products: Array<{ __typename?: 'Product', id: string, name: string }> };

export type ItemTemplateItem_ScopeFragment = { __typename?: 'ItemTemplateItem', id: string, bidItemTemplateItem?: { __typename?: 'ItemTemplateItem', id: string } | null | undefined, basedOn?: { __typename?: 'ItemTemplateItem', totalCostInCents: number, id: string, name: string } | null | undefined, template: { __typename?: 'ItemTemplate', id: string, development?: { __typename?: 'Development', id: string } | null | undefined } };

export type ItemTemplateLineItemsTab_BasedOnIti_OriginalValuesFragment = { __typename?: 'ItemTemplateItem', id: string, name: string, costType: Types.CostType, quantity?: number | null | undefined, unitCostInCents: number, totalCostInCents: number, elevationIds: Array<string>, specOptionIds: Array<string>, otherOptionIds: Array<string>, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, preferredBidContractLineItem?: { __typename?: 'BidContractLineItem', unitCostInCents: number, totalCostInCents: number, id: string, name: string } | null | undefined, baseProduct?: { __typename?: 'Product', id: string, name: string } | null | undefined, bidItem?: { __typename?: 'BidItem', displayName: string, id: string, name: string } | null | undefined };

export const ItemTemplateLineItemsTab_GroupByFragmentDoc = gql`
    fragment ItemTemplateLineItemsTab_GroupBy on ItemTemplateItemVersionGroupTotal {
  groupId
  totalCostInCents
  itivsInGroup
  itivIdsInGroup
  displayName
}
    `;
export const ItemTemplateLineItemsTab_ReadyPlanOptionFragmentDoc = gql`
    fragment ItemTemplateLineItemsTab_ReadyPlanOption on ReadyPlanOption {
  ...Named
  displayName
  shortName
  active
  type {
    ...Named
    isElevation
    isSpecLevel
  }
  parentOption {
    id
    name
    shortName
  }
}
    ${NamedFragmentDoc}`;
export const ItemTemplateDetailFragmentDoc = gql`
    fragment ItemTemplateDetail on ItemTemplate {
  id
  name
  displayName
  canEditLineItems {
    ...PotentialOperationDetails
  }
  readyPlan {
    ...Named
    options {
      ...ItemTemplateLineItemsTab_ReadyPlanOption
    }
  }
  isReadyHomeTemplate
}
    ${PotentialOperationDetailsFragmentDoc}
${NamedFragmentDoc}
${ItemTemplateLineItemsTab_ReadyPlanOptionFragmentDoc}`;
export const ItemTemplateItem_ScopeFragmentDoc = gql`
    fragment ItemTemplateItem_Scope on ItemTemplateItem {
  id
  bidItemTemplateItem {
    id
  }
  basedOn {
    ...Named
    totalCostInCents
  }
  template {
    id
    development {
      id
    }
  }
}
    ${NamedFragmentDoc}`;
export const ItemTemplateItemCostCodeFragmentDoc = gql`
    fragment ItemTemplateItemCostCode on CostCode {
  id
  name
  displayName
}
    `;
export const ItemTemplateItemItemFragmentDoc = gql`
    fragment ItemTemplateItemItem on Item {
  id
  name
  fullCode
  isSelection
  costCode {
    ...ItemTemplateItemCostCode
  }
}
    ${ItemTemplateItemCostCodeFragmentDoc}`;
export const ItemTemplateLineItemsTab_ItemSlotFragmentDoc = gql`
    fragment ItemTemplateLineItemsTab_ItemSlot on ItemSlot {
  ...Named
  item {
    ...ItemTemplateItemItem
  }
  costTypeDetail {
    name
    code
  }
  location {
    id
    name
  }
  unitOfMeasure {
    id
    name
    useQuantity
  }
  isSelection
}
    ${NamedFragmentDoc}
${ItemTemplateItemItemFragmentDoc}`;
export const ItemTemplateItemBidContractLineItemFragmentDoc = gql`
    fragment ItemTemplateItemBidContractLineItem on BidContractLineItem {
  ...Named
  unitCostInCents
  totalCostInCents
}
    ${NamedFragmentDoc}`;
export const ItemTemplateItemBidItemFragmentDoc = gql`
    fragment ItemTemplateItemBidItem on BidItem {
  ...Named
  displayName
  code
  costType {
    code
  }
  unitOfMeasure {
    id
  }
  items {
    id
  }
  products {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const ItemTemplateItemBaseProductFragmentDoc = gql`
    fragment ItemTemplateItemBaseProduct on Product {
  id
  costInCents
  name
  items {
    id
  }
}
    `;
export const ItemTemplateItemLineItemFragmentDoc = gql`
    fragment ItemTemplateItemLineItem on ItemTemplateItemVersion {
  id
  scope {
    ...ItemTemplateItem_Scope
  }
  slot {
    ...ItemTemplateLineItemsTab_ItemSlot
  }
  costType
  quantity
  totalCostInCents
  unitCostInCents
  specifications
  tradePartnerNote
  internalNote
  name
  displayName
  isSelection
  preferredBidContractLineItem {
    ...ItemTemplateItemBidContractLineItem
  }
  location {
    id
    name
  }
  unitOfMeasure {
    id
    name
    useQuantity
  }
  bidItem {
    ...ItemTemplateItemBidItem
  }
  baseProduct {
    ...ItemTemplateItemBaseProduct
    variants {
      ...ItemTemplateItemBaseProduct
    }
  }
  item {
    ...ItemTemplateItemItem
  }
  scopeChangeType
  scopeChangeReasonNote
  scopeChangeReason {
    id
    name
  }
  otherOptionIds
  elevationIds
  specOptionIds
  canEdit {
    ...PotentialOperationDetails
  }
  canDeleteItem {
    ...PotentialOperationDetails
  }
}
    ${ItemTemplateItem_ScopeFragmentDoc}
${ItemTemplateLineItemsTab_ItemSlotFragmentDoc}
${ItemTemplateItemBidContractLineItemFragmentDoc}
${ItemTemplateItemBidItemFragmentDoc}
${ItemTemplateItemBaseProductFragmentDoc}
${ItemTemplateItemItemFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const ItemTemplateLineItemsTab_BasedOnIti_OriginalValuesFragmentDoc = gql`
    fragment ItemTemplateLineItemsTab_BasedOnIti_OriginalValues on ItemTemplateItem {
  id
  name
  location {
    id
    name
  }
  unitOfMeasure {
    id
    name
  }
  costType
  quantity
  unitCostInCents
  totalCostInCents
  preferredBidContractLineItem {
    ...ItemTemplateItemBidContractLineItem
  }
  baseProduct {
    ...Named
  }
  bidItem {
    ...Named
    displayName
  }
  elevationIds
  specOptionIds
  otherOptionIds
}
    ${ItemTemplateItemBidContractLineItemFragmentDoc}
${NamedFragmentDoc}`;
export const ItemTemplateItemLineItemWithChangesFragmentDoc = gql`
    fragment ItemTemplateItemLineItemWithChanges on ItemTemplateItemVersion {
  ...ItemTemplateItemLineItem
  basedOn @include(if: $highlightChanges) {
    ...ItemTemplateLineItemsTab_BasedOnIti_OriginalValues
  }
}
    ${ItemTemplateItemLineItemFragmentDoc}
${ItemTemplateLineItemsTab_BasedOnIti_OriginalValuesFragmentDoc}`;
export const ItemTemplateLineItemsTabDocument = gql`
    query ItemTemplateLineItemsTab($id: ID!) {
  itemTemplate(id: $id) {
    ...ItemTemplateDetail
  }
  unitsOfMeasure {
    ...Named
  }
  locations {
    ...Named
  }
  costCodes {
    ...ItemTemplateItemCostCode
  }
}
    ${ItemTemplateDetailFragmentDoc}
${NamedFragmentDoc}
${ItemTemplateItemCostCodeFragmentDoc}`;

/**
 * __useItemTemplateLineItemsTabQuery__
 *
 * To run a query within a React component, call `useItemTemplateLineItemsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplateLineItemsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplateLineItemsTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useItemTemplateLineItemsTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemTemplateLineItemsTabQuery, ItemTemplateLineItemsTabQueryVariables> & ({ variables: ItemTemplateLineItemsTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplateLineItemsTabQuery, ItemTemplateLineItemsTabQueryVariables>(ItemTemplateLineItemsTabDocument, options);
      }
export function useItemTemplateLineItemsTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplateLineItemsTabQuery, ItemTemplateLineItemsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplateLineItemsTabQuery, ItemTemplateLineItemsTabQueryVariables>(ItemTemplateLineItemsTabDocument, options);
        }
export function useItemTemplateLineItemsTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateLineItemsTabQuery, ItemTemplateLineItemsTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplateLineItemsTabQuery, ItemTemplateLineItemsTabQueryVariables>(ItemTemplateLineItemsTabDocument, options);
        }
export type ItemTemplateLineItemsTabQueryHookResult = ReturnType<typeof useItemTemplateLineItemsTabQuery>;
export type ItemTemplateLineItemsTabLazyQueryHookResult = ReturnType<typeof useItemTemplateLineItemsTabLazyQuery>;
export type ItemTemplateLineItemsTabSuspenseQueryHookResult = ReturnType<typeof useItemTemplateLineItemsTabSuspenseQuery>;
export type ItemTemplateLineItemsTabQueryResult = Apollo.QueryResult<ItemTemplateLineItemsTabQuery, ItemTemplateLineItemsTabQueryVariables>;
export const ItemTemplateItemVersionsPage_GroupsDocument = gql`
    query ItemTemplateItemVersionsPage_Groups($filter: ItemTemplateItemVersionFilter, $order: [ItemTemplateItemVersionOrder!]) {
  itemTemplateItemVersionsPage(filter: $filter, order: $order) {
    groupTotals {
      ...ItemTemplateLineItemsTab_GroupBy
    }
  }
}
    ${ItemTemplateLineItemsTab_GroupByFragmentDoc}`;

/**
 * __useItemTemplateItemVersionsPage_GroupsQuery__
 *
 * To run a query within a React component, call `useItemTemplateItemVersionsPage_GroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplateItemVersionsPage_GroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplateItemVersionsPage_GroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useItemTemplateItemVersionsPage_GroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemTemplateItemVersionsPage_GroupsQuery, ItemTemplateItemVersionsPage_GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplateItemVersionsPage_GroupsQuery, ItemTemplateItemVersionsPage_GroupsQueryVariables>(ItemTemplateItemVersionsPage_GroupsDocument, options);
      }
export function useItemTemplateItemVersionsPage_GroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplateItemVersionsPage_GroupsQuery, ItemTemplateItemVersionsPage_GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplateItemVersionsPage_GroupsQuery, ItemTemplateItemVersionsPage_GroupsQueryVariables>(ItemTemplateItemVersionsPage_GroupsDocument, options);
        }
export function useItemTemplateItemVersionsPage_GroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateItemVersionsPage_GroupsQuery, ItemTemplateItemVersionsPage_GroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplateItemVersionsPage_GroupsQuery, ItemTemplateItemVersionsPage_GroupsQueryVariables>(ItemTemplateItemVersionsPage_GroupsDocument, options);
        }
export type ItemTemplateItemVersionsPage_GroupsQueryHookResult = ReturnType<typeof useItemTemplateItemVersionsPage_GroupsQuery>;
export type ItemTemplateItemVersionsPage_GroupsLazyQueryHookResult = ReturnType<typeof useItemTemplateItemVersionsPage_GroupsLazyQuery>;
export type ItemTemplateItemVersionsPage_GroupsSuspenseQueryHookResult = ReturnType<typeof useItemTemplateItemVersionsPage_GroupsSuspenseQuery>;
export type ItemTemplateItemVersionsPage_GroupsQueryResult = Apollo.QueryResult<ItemTemplateItemVersionsPage_GroupsQuery, ItemTemplateItemVersionsPage_GroupsQueryVariables>;
export const ItemTemplateItemVersionsPageDocument = gql`
    query ItemTemplateItemVersionsPage($filter: ItemTemplateItemVersionFilter, $subFilter: ItemTemplateItemVersionFilter, $highlightChanges: Boolean = false, $first: Int, $offset: Int, $order: [ItemTemplateItemVersionOrder!]) {
  itemTemplateItemVersionsPage(
    filter: $filter
    subFilter: $subFilter
    first: $first
    offset: $offset
    order: $order
  ) {
    items {
      ...ItemTemplateItemLineItemWithChanges
    }
    pageInfo {
      hasNextPage
      totalCount
    }
    groupTotals {
      ...ItemTemplateLineItemsTab_GroupBy
    }
  }
}
    ${ItemTemplateItemLineItemWithChangesFragmentDoc}
${ItemTemplateLineItemsTab_GroupByFragmentDoc}`;

/**
 * __useItemTemplateItemVersionsPageQuery__
 *
 * To run a query within a React component, call `useItemTemplateItemVersionsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplateItemVersionsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplateItemVersionsPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      subFilter: // value for 'subFilter'
 *      highlightChanges: // value for 'highlightChanges'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useItemTemplateItemVersionsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemTemplateItemVersionsPageQuery, ItemTemplateItemVersionsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplateItemVersionsPageQuery, ItemTemplateItemVersionsPageQueryVariables>(ItemTemplateItemVersionsPageDocument, options);
      }
export function useItemTemplateItemVersionsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplateItemVersionsPageQuery, ItemTemplateItemVersionsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplateItemVersionsPageQuery, ItemTemplateItemVersionsPageQueryVariables>(ItemTemplateItemVersionsPageDocument, options);
        }
export function useItemTemplateItemVersionsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateItemVersionsPageQuery, ItemTemplateItemVersionsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplateItemVersionsPageQuery, ItemTemplateItemVersionsPageQueryVariables>(ItemTemplateItemVersionsPageDocument, options);
        }
export type ItemTemplateItemVersionsPageQueryHookResult = ReturnType<typeof useItemTemplateItemVersionsPageQuery>;
export type ItemTemplateItemVersionsPageLazyQueryHookResult = ReturnType<typeof useItemTemplateItemVersionsPageLazyQuery>;
export type ItemTemplateItemVersionsPageSuspenseQueryHookResult = ReturnType<typeof useItemTemplateItemVersionsPageSuspenseQuery>;
export type ItemTemplateItemVersionsPageQueryResult = Apollo.QueryResult<ItemTemplateItemVersionsPageQuery, ItemTemplateItemVersionsPageQueryVariables>;